<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>
              {{ `${this.$t("event.view.title")}` }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mr-3" color="secondary" :to="'/societyadmin/event/edit/'+event.id" >
              <v-icon small left>
                mdi-pencil
              </v-icon>
              Edit
            </v-btn>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("event.view.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10 text--primary">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="4">
                  <v-avatar
                    size="250"
                    v-if="event && event.picture_url != null"
                    tile
                    class="cursor-pointer ml-3 rounded-xl"
                  >
                    <v-img
                      :src="API_BASE_URL + '/uploads/' + event.picture_url"
                      :alt="event.title"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                  <v-avatar
                    v-else
                    color="light grey"
                    class="white--text cursor-pointer ml-3 rounded-xl text-h3"
                    size="250"
                    tile
                  >
                    <span>{{ event.title.charAt(0) }}</span>
                  </v-avatar>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="8">
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("event.view.headers.title")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ event.title }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{
                          `${this.$t("event.view.headers.start_datetime")}`
                        }}
                        :</span
                      >
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9">
                      {{ getFormattedDate(event.start_datetime) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{
                          `${this.$t("event.view.headers.end_datetime")}`
                        }}
                        :</span
                      >
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9">
                      {{ getFormattedDate(event.end_datetime) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("event.view.headers.description")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ event.description }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      event: {
        title: "",
        description: "",
        start_datetime: new Date(),
        end_datetime: new Date(),
        picture_url: "",
      },
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getEventDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/events/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            data.event.start_datetime = new Date(data.event.start_datetime);
            data.event.end_datetime = new Date(data.event.end_datetime);
            _self.event = data.event;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getEventDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.pre-formatted {
  white-space: pre-line !important;
}
</style>